import React, { useEffect, useState } from "react";
import { MdOutlineFilterList } from "react-icons/md";
import { ApiPaths } from "../../Config/ApiPath";
import Loader from "../../Components/Loader/Loader";
import PaginationComponent from "./../../Components/PaginationControls/PaginationControls";
import useAxiosHelper from "../../Common/AxiosHelper";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { BasicInfo } from "../../Config/BasicInfo";
import moment from "moment";
import Change from "../../Common/StringToSub";
const TransferHistory = ({ refresh }) => {
  const [filterVisiblity, setFilterVisiblity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentTransaction, setPaymentTransaction] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitFilter, setLimitFilter] = useState(20);
  const { AxiosGet } = useAxiosHelper();
  const incomeData = useSelector((state) => state.incomeData.incomeWallet);
  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  const [search, setSearch] = useState({
    startDate: "",
    endDate: "",
  });
  var x = 0;
  useEffect(() => {
    if (x === 0) {
      FetchData();
      x++;
    }
  }, [refresh]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  const AddFilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    FetchData(queryParams);
  };

  const FetchData = async (page = currentPage) => {
    try {
      setLoading(true);
      const filteredSearch = Object.fromEntries(
        Object.entries(search).filter(([key, value]) => value !== "")
      );
      const filters = {
        source: "withdrawal",
        ...filteredSearch,
      };
      const queryParams = {
        page,
        limit: limitFilter,
        ...filters,
      };
      const response = await AxiosGet(
        `${ApiPaths.getPaymentTransaction}?${new URLSearchParams(
          queryParams
        ).toString()}`
      );
      BasicInfo.isDebug && console.log("withdraw history", response);
      setPaymentTransaction(response?.data || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching payment transactions:", error);
    } finally {
      setLoading(false);
    }
  };
  function resetData() {
    setSearch({
      startDate: "",
      endDate: "",
    });
    setLimitFilter(20);
    setCurrentPage(1);
  }
  useEffect(() => {
    if (search.startDate === "" && search.endDate === "") {
      FetchData();
    }
  }, [search]);

  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <section className="mt-5">
        <div className="incomeSelectBox">
          <div></div>
          <button onClick={() => setFilterVisiblity(!filterVisiblity)}>
            {filterVisiblity ? "Hide Filters" : "Show Filters"}
            <i>
              {" "}
              <MdOutlineFilterList />
            </i>{" "}
          </button>
        </div>
        {filterVisiblity ? (
          <section className="filtersection inputPrimary">
            <Row>
              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  placeholder="From Date"
                  name="startDate"
                  value={search.startDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  placeholder="End Date"
                  name="endDate"
                  value={search.endDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <div>
                  <select
                    name=""
                    value={limitFilter}
                    onChange={handleLimitChange}
                  >
                    <option value="">--All--</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                </div>
              </Col>
              <Col lg="2" md="4" xs="6">
                <button onClick={AddFilter}>Search</button>
              </Col>
              <Col lg="2" md="4" xs="6">
                <button onClick={() => resetData()}>Reset</button>
              </Col>
            </Row>
          </section>
        ) : null}

        <section className="history">
          <h1 className="textHeading">Transfer History</h1>
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Old Balance</th>
                  <th>Current Balance</th>
                  <th>Category</th>
                  <th>Hash Code</th>
                  <th>Amount ($)</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {paymentTransaction != null && Array.isArray(paymentTransaction)
                  ? paymentTransaction
                      .filter((x) => x?.status !== 2)
                      ?.map((x, i) => {
                        return (
                          <tr>
                            <td>{(currentPage - 1) * limitFilter + (i + 1)}</td>
                            <td>{moment(x?.time).format("lll")}</td>
                            <td>{parseFloat(x?.amount).toFixed(2)}</td>
                            <td>{parseFloat(x?.amount).toFixed(2)}</td>
                            <td>{parseFloat(x?.category).toFixed(2)}</td>
                            <td id="urlLink">
                              <a
                                href={`https://bscscan.com/tx/${x?.tx_hash}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {Change(x?.tx_hash)}
                              </a>
                            </td>
                            <td>{parseFloat(x?.amount).toFixed(2)}</td>
                            {x?.status == "0" ? (
                              <td style={{ color: "var(--colorPrimary" }}>
                                Pending
                              </td>
                            ) : x?.status == "1" ? (
                              <td style={{ color: "green" }}>Success</td>
                            ) : (
                              <td style={{ color: "red" }}>Rejected</td>
                            )}
                          </tr>
                        );
                      })
                  : ""}
              </tbody>
            </table>
            {paymentTransaction == 0 ? <p>No history yet</p> : null}
          </div>
          {paymentTransaction != null && (
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePagination}
            />
          )}
        </section>
      </section>
    </>
  );
};

export default TransferHistory;
